export default __webpack_public_path__ + "static/og-img-1.5M-jackson-galaxy-f9fd945ec1a3acac22083eb11830c85b.png";